import React from "react";
import { Identifiable, Project, Zone } from "@planzone/dto";

const Context = React.createContext<
  | {
      type: "planzone";
    }
  | {
      type: "zone";
      zone: Identifiable<Zone>;
    }
  | {
      type: "project";
      project: Identifiable<Project>;
    }
>({ type: "planzone" });

function useWorkspaceContext() {
  return React.useContext(Context);
}

export { useWorkspaceContext, Context };
